var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"body-box"}},[_c('p',{staticClass:"preload-font"},[_vm._v("一期一会")])])}]

export { render, staticRenderFns }